'use strict';

/** @type {import('./gOPD')} */
module.exports = Object.getOwnPropertyDescriptor;



//////////////////
// WEBPACK FOOTER
// ./~/_gopd@1.2.0@gopd/gOPD.js
// module id = bPpz
// module chunks = 0